import React, { useEffect, useState } from "react";
import "./Message.css";

const messageDesktop =
  "Próximamente vas a poder comprar nuestros productos en la tienda online de VERDIVIA";
const messagePhone = "Próximamente tienda online VERDIVIA";

export const Message = () => {
  const [progress, setProgress] = useState(window.innerWidth);
  const [isHidden, setIsHidden] = useState(false);

  const onScrollX = () => {
    setProgress(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", onScrollX);

    return () => {
      window.removeEventListener("resize", onScrollX);
    };
  }, []);

  const hideMessage = () => {
    setIsHidden(true);
  };

  return (
    <>
      {!isHidden && (
        <div className="message">
          <p>{progress > 950 ? messageDesktop : messagePhone}</p>
          <span onClick={hideMessage}>X</span>
        </div>
      )}
    </>
  );
};
